import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useOutletContext } from 'react-router-dom';
import crmApi, { money, STAGE_META, fmtDate, COUNTRIES, CITIES_BY_COUNTRY } from '../../utils/crmApi';
import useLiveRefresh from '../../utils/useLiveRefresh';

function blankAccount() {
  return { name: '', industry: '', website: '', phone: '', email: '', address: '', city: '', country: 'Oman', tax_id: '', notes: '', billing_address: '', po_box: '', postal_code: '' };
}

export function CrmAccounts() {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [confirmDel, setConfirmDel] = useState(null);
  const [form, setForm] = useState(blankAccount());
  const navigate = useNavigate();

  function load(silent) { if (!silent) setLoading(true); crmApi.get('/accounts').then(setAccounts).finally(() => { if (!silent) setLoading(false); }); }
  useEffect(() => { load(); }, []);
  useLiveRefresh(() => load(true));

  function openNew() { setEditingId(null); setForm(blankAccount()); setShow(true); }
  function openEdit(a) {
    setEditingId(a.id);
    setForm({ name: a.name || '', industry: a.industry || '', website: a.website || '', phone: a.phone || '', email: a.email || '', address: a.address || '', city: a.city || '', country: a.country || 'Oman', tax_id: a.tax_id || '', notes: a.notes || '', billing_address: a.billing_address || '', po_box: a.po_box || '', postal_code: a.postal_code || '' });
    setShow(true);
  }
  async function save() {
    if (!form.name.trim()) return;
    if (editingId) await crmApi.put(`/accounts/${editingId}`, form);
    else await crmApi.post('/accounts', form);
    setShow(false); setEditingId(null); setForm(blankAccount()); load();
  }
  async function doDelete() {
    if (!confirmDel) return;
    try { await crmApi.delete(`/accounts/${confirmDel.id}`); setConfirmDel(null); load(); }
    catch (e) { setConfirmDel(null); }
  }
  function setCountry(c) { setForm(f => ({ ...f, country: c, city: '' })); }
  const cityOptions = CITIES_BY_COUNTRY[form.country] || CITIES_BY_COUNTRY['Other'];

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
        <div>
          <h1 style={{ fontSize: '20px', fontWeight: '800' }}>Accounts</h1>
          <p style={{ fontSize: '13px', color: 'var(--muted)' }}>Companies on record — for history, communication and invoicing.</p>
        </div>
        <button className="btn btn-primary" style={{ marginLeft: 'auto' }} onClick={openNew}>+ New Account</button>
      </div>

      <div className="card" style={{ overflow: 'hidden' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1.5fr 1fr 70px 70px 130px', background: 'var(--surface2)', borderBottom: '1px solid var(--border)' }}>
          {['Company', 'Email / Phone', 'Location', 'Deals', 'Contacts', 'Actions'].map(h => (
            <div key={h} style={{ padding: '10px 16px', fontSize: '11px', fontWeight: '700', color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.6px' }}>{h}</div>
          ))}
        </div>
        {loading ? <div style={{ padding: '20px', color: 'var(--muted)' }}>Loading…</div> :
          accounts.length === 0 ? <div style={{ padding: '24px', textAlign: 'center', color: 'var(--muted)', fontSize: '13px' }}>No accounts yet.</div> :
            accounts.map((a, i) => (
              <div key={a.id}
                style={{ display: 'grid', gridTemplateColumns: '2fr 1.5fr 1fr 70px 70px 130px', borderBottom: i < accounts.length - 1 ? '1px solid var(--border)' : 'none', alignItems: 'center' }}
                onMouseEnter={e => e.currentTarget.style.background = 'var(--surface2)'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                <div style={{ padding: '12px 16px', cursor: 'pointer' }} onClick={() => navigate(`/crm/accounts/${a.id}`)}>
                  <div style={{ fontSize: '13px', fontWeight: '700' }}>{a.name}</div>
                  {a.industry && <div style={{ fontSize: '11px', color: 'var(--muted)' }}>{a.industry}</div>}
                </div>
                <div style={{ padding: '12px 16px', fontSize: '12px', color: 'var(--muted2)' }}>{a.email || '—'}<br /><span style={{ fontSize: '11px', color: 'var(--muted)' }}>{a.phone || ''}</span></div>
                <div style={{ padding: '12px 16px', fontSize: '12px', color: 'var(--muted2)' }}>{[a.city, a.country].filter(Boolean).join(', ') || '—'}</div>
                <div style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '700' }}>{a.deal_count}</div>
                <div style={{ padding: '12px 16px', fontSize: '13px', fontWeight: '700' }}>{a.contact_count}</div>
                <div style={{ padding: '8px 10px', display: 'flex', gap: '5px', justifyContent: 'flex-end' }}>
                  <button className="btn btn-sm" onClick={(e) => { e.stopPropagation(); openEdit(a); }}>Edit</button>
                  <button className="btn btn-sm" style={{ color: '#DC2626' }} onClick={(e) => { e.stopPropagation(); setConfirmDel(a); }}>Delete</button>
                </div>
              </div>
            ))}
      </div>

      {show && (
        <div className="modal-overlay" onClick={e => { if (e.target === e.currentTarget) setShow(false); }}>
          <div className="modal" style={{ width: '540px', maxHeight: '90vh', overflowY: 'auto' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '800', marginBottom: '16px' }}>{editingId ? 'Edit Account' : 'New Account'}</h3>
            <div className="form-group"><label className="form-label">Company Name *</label><input className="input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /></div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div className="form-group" style={{ flex: 1 }}><label className="form-label">Industry</label><input className="input" value={form.industry} onChange={e => setForm({ ...form, industry: e.target.value })} /></div>
              <div className="form-group" style={{ flex: 1 }}><label className="form-label">Website</label><input className="input" value={form.website} onChange={e => setForm({ ...form, website: e.target.value })} /></div>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div className="form-group" style={{ flex: 1 }}><label className="form-label">Email</label><input className="input" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} /></div>
              <div className="form-group" style={{ flex: 1 }}><label className="form-label">Phone</label><input className="input" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} /></div>
            </div>

            <div style={{ fontSize: '11px', fontWeight: '700', color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.5px', margin: '6px 0 8px' }}>Address</div>
            <div className="form-group"><label className="form-label">Street Address</label><input className="input" value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} /></div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div className="form-group" style={{ flex: 1 }}><label className="form-label">P.O. Box</label><input className="input" value={form.po_box} onChange={e => setForm({ ...form, po_box: e.target.value })} /></div>
              <div className="form-group" style={{ flex: 1 }}><label className="form-label">Postal Code</label><input className="input" value={form.postal_code} onChange={e => setForm({ ...form, postal_code: e.target.value })} /></div>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div className="form-group" style={{ flex: 1 }}><label className="form-label">Country</label>
                <select className="select" value={form.country} onChange={e => setCountry(e.target.value)}>
                  {COUNTRIES.map(co => <option key={co} value={co}>{co}</option>)}
                </select>
              </div>
              <div className="form-group" style={{ flex: 1 }}><label className="form-label">City</label>
                <select className="select" value={form.city} onChange={e => setForm({ ...form, city: e.target.value })}>
                  <option value="">— Select city —</option>
                  {cityOptions.map(ct => <option key={ct} value={ct}>{ct}</option>)}
                </select>
              </div>
              <div className="form-group" style={{ flex: 1 }}><label className="form-label">VATIN <span style={{ color: 'var(--muted)', fontWeight: 400, fontSize: 10 }}>(VAT no.)</span></label><input className="input" value={form.tax_id} onChange={e => setForm({ ...form, tax_id: e.target.value })} /></div>
            </div>

            <div style={{ fontSize: '11px', fontWeight: '700', color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.5px', margin: '6px 0 8px' }}>Billing</div>
            <div className="form-group"><label className="form-label">Billing Address <span style={{ color: 'var(--muted)', fontWeight: 400, fontSize: 10 }}>(if different from above)</span></label><input className="input" value={form.billing_address} onChange={e => setForm({ ...form, billing_address: e.target.value })} placeholder="Leave blank to use the address above" /></div>

            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', paddingTop: '12px', borderTop: '1px solid var(--border)' }}>
              <button className="btn" onClick={() => setShow(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={save}>{editingId ? 'Save Changes' : 'Create Account'}</button>
            </div>
          </div>
        </div>
      )}
      {confirmDel && (
        <div className="modal-overlay" onClick={e => { if (e.target === e.currentTarget) setConfirmDel(null); }}>
          <div className="modal" style={{ width: '380px' }}>
            <h3 style={{ fontSize: '15px', fontWeight: '800', marginBottom: '8px' }}>Delete account?</h3>
            <p style={{ fontSize: '13px', color: 'var(--muted2)', lineHeight: 1.6, marginBottom: '14px' }}><strong>{confirmDel.name}</strong> will be removed. Linked deals and documents keep their reference.</p>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button className="btn" onClick={() => setConfirmDel(null)}>Cancel</button>
              <button className="btn" style={{ background: '#DC2626', color: '#fff', borderColor: '#DC2626' }} onClick={doDelete}>Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export function CrmAccountDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [acc, setAcc] = useState(null);
  const [showContact, setShowContact] = useState(false);
  const [contact, setContact] = useState({ first_name: '', last_name: '', title: '', email: '', phone: '' });

  function load() { crmApi.get(`/accounts/${id}`).then(setAcc).catch(() => {}); }
  useEffect(() => { load(); }, [id]);

  async function addContact() {
    if (!contact.first_name.trim()) return;
    await crmApi.post('/contacts', { ...contact, account_id: id });
    setShowContact(false); setContact({ first_name: '', last_name: '', title: '', email: '', phone: '' }); load();
  }

  if (!acc) return <div style={{ color: 'var(--muted)' }}>Loading…</div>;

  return (
    <div>
      <button className="btn" style={{ marginBottom: '14px' }} onClick={() => navigate('/crm/accounts')}>← Accounts</button>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: '16px', alignItems: 'start' }}>
        <div className="card" style={{ padding: '18px' }}>
          <h1 style={{ fontSize: '19px', fontWeight: '800' }}>{acc.name}</h1>
          {acc.industry && <div style={{ fontSize: '12px', color: 'var(--muted)', marginBottom: '14px' }}>{acc.industry}</div>}
          {[['Email', acc.email], ['Phone', acc.phone], ['Website', acc.website], ['Address', acc.address], ['P.O. Box', acc.po_box], ['Postal Code', acc.postal_code], ['City', acc.city], ['Country', acc.country], ['VATIN', acc.tax_id], ['Billing Address', acc.billing_address]].map(([k, v]) => v && (
            <div key={k} style={{ display: 'flex', gap: '10px', padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
              <span style={{ fontSize: '11px', fontWeight: '700', color: 'var(--muted)', width: '110px', flexShrink: 0, textTransform: 'uppercase' }}>{k}</span>
              <span style={{ fontSize: '13px', color: 'var(--text)' }}>{v}</span>
            </div>
          ))}
          {acc.notes && <p style={{ fontSize: '12px', color: 'var(--muted2)', marginTop: '12px' }}>{acc.notes}</p>}
        </div>

        <div>
          {/* Contacts */}
          <div className="card" style={{ padding: '18px', marginBottom: '14px' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
              <div style={{ fontSize: '14px', fontWeight: '800' }}>Contacts</div>
              <button className="btn btn-sm" style={{ marginLeft: 'auto' }} onClick={() => setShowContact(true)}>+ Add</button>
            </div>
            {acc.contacts.length === 0 && <div style={{ fontSize: '12px', color: 'var(--muted)' }}>No contacts.</div>}
            {acc.contacts.map(c => (
              <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 0', borderBottom: '1px solid var(--border)' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '13px', fontWeight: '600' }}>{c.first_name} {c.last_name} {c.is_primary ? <span style={{ fontSize: '9px', color: '#0D9488', fontWeight: '700' }}>★ PRIMARY</span> : ''}</div>
                  <div style={{ fontSize: '11px', color: 'var(--muted)' }}>{c.title} {c.email ? `· ${c.email}` : ''} {c.phone ? `· ${c.phone}` : ''}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Deals */}
          <div className="card" style={{ padding: '18px', marginBottom: '14px' }}>
            <div style={{ fontSize: '14px', fontWeight: '800', marginBottom: '10px' }}>Deals</div>
            {acc.deals.length === 0 && <div style={{ fontSize: '12px', color: 'var(--muted)' }}>No deals.</div>}
            {acc.deals.map(d => (
              <div key={d.id} onClick={() => navigate(`/crm/deals/${d.id}`)} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 0', borderBottom: '1px solid var(--border)', cursor: 'pointer' }}>
                <div style={{ flex: 1 }}><div style={{ fontSize: '13px', fontWeight: '600' }}>{d.title}</div></div>
                <span style={{ fontSize: '13px', fontWeight: '700', color: '#0D9488' }}>{money(d.value, d.currency)}</span>
                <span style={{ fontSize: '10px', fontWeight: '700', padding: '2px 9px', borderRadius: '99px', background: STAGE_META[d.stage]?.bg, color: STAGE_META[d.stage]?.color }}>{STAGE_META[d.stage]?.label}</span>
              </div>
            ))}
          </div>

          {/* Documents */}
          <div className="card" style={{ padding: '18px' }}>
            <div style={{ fontSize: '14px', fontWeight: '800', marginBottom: '10px' }}>Documents</div>
            {acc.documents.length === 0 && <div style={{ fontSize: '12px', color: 'var(--muted)' }}>No documents.</div>}
            {acc.documents.map(doc => (
              <div key={doc.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 0', borderBottom: '1px solid var(--border)' }}>
                <span style={{ fontSize: '11px', color: 'var(--muted)', textTransform: 'capitalize', width: '80px' }}>{doc.doc_type.replace('_', ' ')}</span>
                <span style={{ fontSize: '12px', fontWeight: '600', fontFamily: 'var(--font-mono)' }}>{doc.doc_number}</span>
                <span style={{ marginLeft: 'auto', fontSize: '13px', fontWeight: '700' }}>{money(doc.total, doc.currency)}</span>
                <span style={{ fontSize: '11px', color: 'var(--muted)' }}>{fmtDate(doc.issue_date)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {showContact && (
        <div className="modal-overlay" onClick={e => { if (e.target === e.currentTarget) setShowContact(false); }}>
          <div className="modal" style={{ width: '420px' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '800', marginBottom: '16px' }}>Add Contact</h3>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div className="form-group" style={{ flex: 1 }}><label className="form-label">First Name *</label><input className="input" value={contact.first_name} onChange={e => setContact({ ...contact, first_name: e.target.value })} /></div>
              <div className="form-group" style={{ flex: 1 }}><label className="form-label">Last Name</label><input className="input" value={contact.last_name} onChange={e => setContact({ ...contact, last_name: e.target.value })} /></div>
            </div>
            <div className="form-group"><label className="form-label">Title</label><input className="input" value={contact.title} onChange={e => setContact({ ...contact, title: e.target.value })} /></div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div className="form-group" style={{ flex: 1 }}><label className="form-label">Email</label><input className="input" value={contact.email} onChange={e => setContact({ ...contact, email: e.target.value })} /></div>
              <div className="form-group" style={{ flex: 1 }}><label className="form-label">Phone</label><input className="input" value={contact.phone} onChange={e => setContact({ ...contact, phone: e.target.value })} /></div>
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', marginBottom: '14px' }}>
              <input type="checkbox" checked={!!contact.is_primary} onChange={e => setContact({ ...contact, is_primary: e.target.checked })} /> Primary contact
            </label>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button className="btn" onClick={() => setShowContact(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={addContact}>Add</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
